import React from 'react';
import { Link } from 'react-router-dom';

export function LegalFooter() {
  return (
    <div className="mt-8 text-center">
      <div className="flex items-center justify-center space-x-4 text-sm text-gray-600 dark:text-gray-400">
        <Link 
          to="/impressum" 
          className="hover:text-gray-900 dark:hover:text-white transition-colors"
        >
          Impressum
        </Link>
        <span className="text-gray-400">•</span>
        <Link 
          to="/datenschutz" 
          className="hover:text-gray-900 dark:hover:text-white transition-colors"
        >
          Datenschutz
        </Link>
        <span className="text-gray-400">•</span>
        <Link 
          to="/agb" 
          className="hover:text-gray-900 dark:hover:text-white transition-colors"
        >
          AGB
        </Link>
      </div>
    </div>
  );
}
